import classNames from 'classnames';
import PropTypes from 'prop-types';

// One explain-mode marker: on the top-right corner of the element it explains, or
// left of the label and vertically centred on a side-menu entry. Filled while
// unread and hollow once explained, so what is new after a release stands out. A
// real button: keyboard reachable, labelled with the item title and its state.
// The ::before ring is the touch target around the small visible dot.
function ExplainMarker({
  id, label, read, left, top, onClick,
}) {
  return (
    <button
      type="button"
      data-explain-marker={id}
      aria-label={label}
      onClick={onClick}
      style={{ left, top }}
      className={classNames(
        'absolute w-[22px] h-[22px] p-0 rounded-full border-2 flex items-center justify-center',
        'text-[13px] font-bold leading-none shadow-button-tiny cursor-pointer pointer-events-auto',
        'before:content-[\'\'] before:absolute before:-inset-2',
        'animate-[pxExplainReveal_180ms_ease-out] motion-reduce:animate-none',
        'hover:scale-110 motion-reduce:hover:scale-100',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pxTxt',
        read ? 'bg-white border-pxHelp text-pxHelp' : 'bg-pxHelp border-white text-white',
      )}
    >
      ?
    </button>
  );
}

ExplainMarker.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  read: PropTypes.bool,
  left: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ExplainMarker;
